import { svg } from 'lit';

const symbol = svg`<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.25 5.25V3.75C2.25 3.35218 2.25 2.25 2.25 2.25C2.25 2.25 3.35218 2.25 3.75 2.25H5.25" stroke="white" stroke-width="0.5" stroke-linecap="square" stroke-linejoin="round"/>
<path d="M12.75 2.25H14.25C14.6478 2.25 15.75 2.25 15.75 2.25C15.75 2.25 15.75 3.35218 15.75 3.75V5.25" stroke="white" stroke-width="0.5" stroke-linecap="square" stroke-linejoin="round"/>
<path d="M15.75 12.75V14.25C15.75 14.6478 15.75 15.75 15.75 15.75C15.75 15.75 14.6478 15.75 14.25 15.75H12.75" stroke="white" stroke-width="0.5" stroke-linecap="square" stroke-linejoin="round"/>
<path d="M5.2515 15.75H3.7515C3.35368 15.75 2.25 15.75 2.25 15.75C2.25 15.75 2.2515 14.6478 2.2515 14.25V12.75" stroke="white" stroke-width="0.5" stroke-linecap="square" stroke-linejoin="round"/>
</svg>`;

export { symbol as default };

